import Container from "@/components/common/Container";
import Title from "@/components/common/Title";
import Image from "next/image";

const CustomizedSolutions = () => (
  <Container small>
    <Title
      description="Empower Your Applications with Seamless Data Integration: Elevate your projects with our cutting-edge&nbsp;<a href='https://ultroneous.com/web-scraping-services'>web scraping API services</a>&nbsp;for effortless access to valuable online data."
      descriptionClass="text-base text-primary-black text-center font-light md:px-12 md:mx-12 pb-10 md:pb-24"
      subTitle="Web Scraping API: Customized Solutions"
      subTitleClass="text-4xl md:text-6xl text-primary-black text-center mb-6 lg:mb-4 lg:pb-2 pt-20 md:pt-40"
    />
    <div className="flex flex-col lg:flex-row pb-14 lg:pb-36">
      <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
        <div className="fs-0 rounded-2xl">
          <Image
            alt="eCommerce Web Scraping API"
            height={416}
            src="/assets/data-solution/ecommercedatascraping.webp"
            width={648}
          />
        </div>
      </div>
      <div className="w-full lg:w-1/2 lg:pl-12">
        <h3 className="text-xl md:text-4xl text-black fw-normal mb-4 xl:pt-4">
          <span>eCommerce Web Scraping API</span>
        </h3>
        <p className="text-sm md:text-base text-black font-normal text-justify">
          <span>
            Revolutionize your market strategy with our eCommerce&nbsp;
            <b>Web Scraping API.</b>&nbsp;Gain a competitive edge by extracting
            valuable data, tracking product trends, and monitoring competitor
            pricing, ensuring your business stays ahead in the dynamic online
            retail landscape.
          </span>
        </p>
      </div>
    </div>
    <div className="flex flex-col lg:flex-row-reverse pb-14 lg:pb-36">
      <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
        <div className="fs-0 rounded-2xl">
          <Image
            alt="eCommerce Web Scraping API"
            height={416}
            src="/assets/data-solution/foodgrocerydatascraping.webp"
            width={648}
          />
        </div>
      </div>
      <div className="w-full lg:w-1/2 lg:pr-12">
        <h3 className="text-xl md:text-4xl text-black fw-normal mb-4 xl:pt-4">
          <span>Food & Grocery Web Scraping API</span>
        </h3>
        <p className="text-sm md:text-base text-black font-normal text-justify">
          <span>
            Navigate the Food & Grocery industry effortlessly with our&nbsp;
            <b>Web Scraping API.</b>&nbsp;Access real-time pricing, product
            availability, and competitor insights. Stay agile in the market by
            making data-driven decisions for optimal inventory management and
            pricing strategies.
          </span>
        </p>
      </div>
    </div>
    <div className="flex flex-col lg:flex-row pb-14 lg:pb-36">
      <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
        <div className="fs-0 rounded-2xl">
          <Image
            alt="eCommerce Web Scraping API"
            height={416}
            src="/assets/data-solution/socialmediadatascraping.webp"
            width={648}
          />
        </div>
      </div>
      <div className="w-full lg:w-1/2 lg:pl-12">
        <h3 className="text-xl md:text-4xl text-black fw-normal mb-4 xl:pt-4">
          <span>Social Media Web Scraping API</span>
        </h3>
        <p className="text-sm md:text-base text-black font-normal text-justify">
          <span>
            Harness the power of social data with our Social Media&nbsp;
            <b>Web Scraping API.</b>&nbsp;Monitor trends, analyze user
            engagement, and gain valuable insights for strategic marketing
            decisions. Unlock the potential of user-generated content and
            sentiment analysis to enhance your brand&nbsp;s online presence.
          </span>
        </p>
      </div>
    </div>
    <div className="flex flex-col lg:flex-row-reverse">
      <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
        <div className="fs-0 rounded-2xl">
          <Image
            alt="eCommerce Web Scraping API"
            height={416}
            src="/assets/data-solution/realestatedatascraping.webp"
            width={648}
          />
        </div>
      </div>
      <div className="w-full lg:w-1/2 lg:pr-12">
        <h3 className="text-xl md:text-4xl text-black fw-normal mb-4 xl:pt-4">
          <span>Real Estate Web Scraping API</span>
        </h3>
        <p className="text-sm md:text-base text-black font-normal text-justify">
          <span>
            Immerse yourself in the real estate market with our
            specialized&nbsp;
            <b>Web Scraping API.</b>&nbsp;Access property listings, market
            trends, and pricing data to make informed investment decisions. Stay
            ahead in the competitive real estate landscape by leveraging
            accurate and up-to-date information for strategic planning.
          </span>
        </p>
      </div>
    </div>
  </Container>
);

export default CustomizedSolutions;
